import React, { useState } from "react";
import { Button } from "../../controls";
import { DownloadRounded } from "@mui/icons-material";
import { Server } from "../../api/Server";
import { downloadBlobFromResponse, ToFormData } from "../../hooks/Method";

const Export = ({ endpoint, value, label = "Export Report" }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = () => {
    setLoading(true);
    Server(endpoint).postFile(ToFormData(value), (res, err) => {
      setLoading(false);
      if (err) return console.error("Export failed");
      downloadBlobFromResponse(res);
    });
  };

  return (
    <Button
      disabled={loading}
      onClick={handleExport}
      className="w-full md:w-auto"
      sx={{
        width: { xs: "100%", md: "auto" },
      }}
      variant="text"
      startIcon={!loading && <DownloadRounded />}
    >
      {loading ? "Generating..." : label}
    </Button>
  );
};

export default Export;
